import { jsxs as e, jsx as t } from "react/jsx-runtime";

import r from "@ui-components-3/icons/lib/regular/CalendarClock";

const a = ({description: a}) => e("div", {
    className: "flex flex-col gap-6",
    children: [ t("div", {
        className: "flex items-center justify-center py-9",
        children: t(r, {
            "aria-hidden": "true",
            className: "text-primary-100 h-auto w-[145px]"
        })
    }), !!a && t("p", {
        className: "typography-body-l text-center font-medium text-neutral-500",
        children: a
    }) ]
});

export { a as default };
//# sourceMappingURL=DrawerEmptyState.js.map
